import { render } from "./ArcheryResults.vue?vue&type=template&id=2de6b27e&scoped=true"
import script from "./ArcheryResults.vue?vue&type=script&lang=js"
export * from "./ArcheryResults.vue?vue&type=script&lang=js"

import "./ArcheryResults.vue?vue&type=style&index=0&id=2de6b27e&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0add72b42d7a2609c-1/assemble-sports/unisports-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de6b27e"]])

export default __exports__